/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
/* eslint-disable eqeqeq */
/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
globalThis.mutationMain = () => {
  const config = {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true,
  };

  const cartObserver = new MutationObserver(function (mutations) {
    if (mutations.length > 0) {
      // this place for code after mutation
    }
  });

  cartObserver.observe($('#MainContent')[0], config);

  $(document).on('shopify:section:select', function (event) {
    if (event.target.className.indexOf('shopify-section-cookies') > 0) cookies._run();
  });
};

globalThis._setCookie = function (cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
};

globalThis._getCookie = function (cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

globalThis.cookies = {
  _init: () => {
    if (_getCookie('page-cookies') === $('#shopify-section-cookies [data-cookies-version]').data('cookies-version')) $('#shopify-section-cookies').addClass('hide');
    else $('#shopify-section-cookies').addClass('installed');
    $(document).on('click', '.cookies__btn-close', function () {
      _setCookie('page-cookies', $('#shopify-section-cookies [data-cookies-version]').data('cookies-version'), 30);
      $('#shopify-section-cookies').hide('slow');
    });
  },
  _run: () => cookies._init(),
};
(globalThis.shopTheLook = {
  selectors: {
    shopTheLookData: '.shop-the-look__item',
    img: '.shop-the-look__img',
    size: '.shop-the-look__sizes',
    price: '.shop-the-look__price',
    btn: '.shop-the-look__basket',
    btnText: '.shop-the-look__basket .text',
    title: '.shop-the-look__title',
    onlyText: '.text',
    loader: '.loader',
    firstSize: '.shop-the-look__size-item:first-child',
    changeSize: '.shop-the-look__size-item',
    error: '.shop-the-look__error',
  },
  _initProduct: (product) => {
    const $item = $(`[data-attr="${product.handle}"]`);

    $item.find(shopTheLook.selectors.img).append(`<img src="${product.images[0]})" alt="${product.title}"/>`);
    $item.find(shopTheLook.selectors.img).attr('href', product.url);
    $item.find(shopTheLook.selectors.title).append(`<h3>${product.title}</h3>`);

    $.each(product.variants, (i, e) => {
      if (e.available == true) {
        $item.find(shopTheLook.selectors.size).append(`<div class="${e.available} shop-the-look__size-item" data-attr=${e.id}>${e.title}</div>`);
        $item.find(shopTheLook.selectors.changeSize).on('click', (e) => {
          if ($(e.currentTarget).hasClass('false')) {
            $(e.currentTarget).parent().parent().find(shopTheLook.selectors.btnText).text(theme.strings.soldOut);
            $(e.currentTarget).parent().parent().find(shopTheLook.selectors.btn).attr('aria-disabled', true);
          } else {
            $(e.currentTarget).parent().parent().find(shopTheLook.selectors.btnText).text(theme.strings.addToCart);
            $(e.currentTarget).parent().parent().find(shopTheLook.selectors.btn).removeAttr('aria-disabled');
          }
          $(e.currentTarget).parent().find(shopTheLook.selectors.changeSize).removeClass('active');
          $(e.currentTarget).addClass('active');
          $(e.currentTarget).parent().parent().find(shopTheLook.selectors.btn).attr('data-id', $(e.currentTarget).attr('data-attr'));
        });
      }
    });

    if ($item.find(shopTheLook.selectors.firstSize).hasClass('false')) {
      $item.find(shopTheLook.selectors.btn).attr('aria-disabled', true);
      $item.find(shopTheLook.selectors.btnText).text(theme.strings.soldOut);
    }

    $item.find(shopTheLook.selectors.price).append(`<div class="shop-the-look__price-normal">${theme.Currency.formatMoney(product.price, theme.moneyFormat)}</div>`);

    if (product.compare_at_price > product.price) {
      $item.find(shopTheLook.selectors.price).append(`<div class="shop-the-look__price-old">${theme.Currency.formatMoney(product.compare_at_price, theme.moneyFormat)}</div>`);
    }

    $item.find(shopTheLook.selectors.btn).attr('data-id', $item.find(shopTheLook.selectors.firstSize).attr('data-attr'));
    $item.find(shopTheLook.selectors.btn).removeAttr('disabled');
    $item.find(shopTheLook.selectors.firstSize).addClass('active');

    if ($item.find(shopTheLook.selectors.firstSize).hasClass('false')) {
      $item.find(shopTheLook.selectors.btnText).text(theme.strings.soldOut);
    }

    $(shopTheLook.selectors.btn, $item).on('click', function () {
      const $btn = $(this);
      const id = $btn.attr('data-id');
      const formData = {
        items: [
          {
            id,
            quantity: 1,
          },
        ],
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then(async function (response) {
          if (!response.ok) {
            const body = await response.text();
            throw Error(JSON.parse(body).description);
          }
          return response;
        })
        .then(function (response) {
          const $onlyText = $btn.find(shopTheLook.selectors.onlyText);
          const $loader = $btn.find(shopTheLook.selectors.loader);

          $onlyText.text('');
          $loader.removeClass('hide');
          setTimeout(() => {
            $loader.addClass('hide');
            $onlyText.text('Dodano do koszyka!');
            setTimeout(() => {
              $loader.addClass('hide');
              $onlyText.text(theme.strings.addToCart);
            }, 2000);
          }, 200);
          $btn.parent().find(shopTheLook.selectors.error).text('');
        })
        .catch(function (error) {
          $btn.parent().find(shopTheLook.selectors.error).text(error);
          console.error('Error:', error);
        });
    });
  },
  _init: () => {
    if ($(shopTheLook.selectors.shopTheLookData).length > 0) {
      const swiperShopTheLook = new Swiper('.shop-the-look', {
        slidesPerView: 1,
        spaceBetween: 0,
        observer: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          980: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 60,
          },
        },
      });
      const count = $(shopTheLook.selectors.shopTheLookData).length;
      $(shopTheLook.selectors.shopTheLookData).each((i, e) => {
        const handle = $(e).data('attr');

        fetch(`/products/${handle}.js`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(async function (response) {
            if (!response.ok) {
              $(`[data-attr="${handle}"]`).remove();
            }
            return response;
          })
          .then(async function (response) {
            const product = await response.json();
            shopTheLook._initProduct(product);
            if ($(e).find(shopTheLook.selectors.changeSize).length == 0) {
              $(e).remove();
            }
          });
        $(shopTheLook.selectors.changeSize).on('click', (e) => {
          if ($(e).hasClass('false')) {
            $(e).parent().parent().find(shopTheLook.selectors.btnText).text(theme.strings.soldOut);
          } else {
            $(e).parent().parent().find(shopTheLook.selectors.btnText).text(theme.strings.addToCart);
          }
        });
      });
    }
  },
  _run: () => shopTheLook._init(),
}),
  (globalThis.menu = {
    selectors: {
      menuTextLink: '.gm-text',
      menuLinks: '.gm-target',
    },
    _init: () => {
      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if ($(mutation.target).hasClass('gm-menu')) {
            $(menu.selectors.menuLinks).each(function () {
              if ($(this).css('background-color') != 'rgb(0, 0, 0)' || $(this).css('background-color') != 'rgba(0, 0, 0, 0)') {
                const el = $(this);
                const savedBackground = $(el).css('background-color');
                setTimeout(() => {
                  $(el).css('cssText', `background-color: ${savedBackground} !important`);
                }, 100);
              }
            });
          }
        }
      }).observe(document.querySelector('#AccessibleNav'), { subtree: true, childList: true });
      $(menu.selectors.menuTextLink).on('click', function (e) {
        e.stopPropagation();
        $(this).parent().trigger('click');
      });
    },
    _run: () => menu._init(),
  });
(globalThis.collectionView = {
  selectors: {
    templateSearch: '.snize-results-page',
    templateCollection: '.template-collection',
    productSizeContainers: '.snize-size-select-box',
    unavailableClass: '.snize-size-unavailable',
    unavailableActiveEl: '.snize-size-active.snize-size-unavailable',
    sizes: '.snize-size',
    mainContent: '.main-content',
    sizesContainer: 'snize-overhidden',
  },
  _init: () => {
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if ($(mutation.target).hasClass(collectionView.selectors.sizesContainer)) {
          collectionView._initializeActiveSizes();
        }
      }
    }).observe(document.querySelector(collectionView.selectors.mainContent), { subtree: true, childList: true });
  },
  _initializeActiveSizes: () => {
    const productWithSizes = $(collectionView.selectors.productSizeContainers);
    $(productWithSizes).each(function () {
      if ($(this).find(collectionView.selectors.unavailableActiveEl).length) {
        const firstAvailableSize = $(this).find(collectionView.selectors.sizes).not(collectionView.selectors.unavailableClass).get(0);
        if ($(firstAvailableSize).length) {
          $(firstAvailableSize).click();
        }
      }
    });
  },
  _run: () => {
    if ($(collectionView.selectors.templateCollection).length || $(collectionView.selectors.templateSearch).length) {
      collectionView._init();
    }
  },
}),
  (globalThis.searchaniseCustomization = {
    selectors: {
      recomendationSlider: '.snize-recommendation-results .overview',
      recomendationNextButton: '.snize-recommendation-results .next',
    },
    _init: () => {
      const styleObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutationRecord) {
          const el = $(mutationRecord.target);
          const maxLeftMargin = Math.abs(Number($(el).css('marginLeft').replace('px', ''))) + Number($(window).outerWidth());
          if (maxLeftMargin >= $(el).outerWidth()) {
            $(el).closest('.snize-recommendation-results').find('.next').addClass('disable');
          } else {
            $(el).closest('.snize-recommendation-results').find('.next').removeClass('disable');
          }
          if (maxLeftMargin > $(el).outerWidth()) {
            $(el).css({ marginLeft: -Math.abs($(el).outerWidth() - $(window).outerWidth()) });
          }
        });
      });
      let count = 0;
      const ReservationInterval = setInterval(() => {
        count++;
        if ($(window).outerWidth() > theme.breakpoints.phone) {
          clearInterval(ReservationInterval);
          return;
        }
        if ($(searchaniseCustomization.selectors.recomendationSlider).length) {
          const sliders = document.querySelectorAll(searchaniseCustomization.selectors.recomendationSlider);
          let i;
          for (i = 0; i < sliders.length; i++) {
            styleObserver.observe(sliders[i], { attributes: true, attributeFilter: ['style'] });
          }

          $(window).on('resize', searchaniseCustomization._onResize);
          if ($(window).outerWidth() <= theme.breakpoints.medium) {
            searchaniseCustomization._customizeDimensionsOfRecommendations();
          }
          count = 20;
        }
        if (count > 19) {
          clearInterval(ReservationInterval);
        }
      }, 500);
    },
    _onResize() {
      if ($(window).outerWidth() > theme.breakpoints.medium) {
        return;
      }
      searchaniseCustomization._customizeDimensionsOfRecommendations();
    },
    _customizeDimensionsOfRecommendations() {
      const sliders = $(searchaniseCustomization.selectors.recomendationSlider);
      for (const slider of sliders) {
        const slides = $(slider).children();
        const halfViewportWidth = $(slider).closest('.viewport').outerWidth() / 2;
        for (const slide of slides) {
          const slideMargins = $(slide).css('margin-right').replace('px', '') * 2;
          $(slide).css({ width: `${halfViewportWidth - slideMargins}px` });
        }
        $(slider).outerWidth($(slides).first().outerWidth(true) * slides.length);
      }
    },
    _run: () => searchaniseCustomization._init(),
  }),
  (globalThis.fitGuide = {
    selectors: {
      tabID: 'data-tab-id',
      tabsWrapper: '.fit-guide__tabs',
      menuWrapper: '.fit-guide__menu',
      menuItem: '.menu__button',
      tab: '.accordion__tab',
      activeClass: 'active',
      tabHeader: '.tab__header',
      accordionHeadClass: 'accordion__head',
    },
    _init: () => {
      const tabsWrapper = $(fitGuide.selectors.tabsWrapper);
      const menuWrapper = $(fitGuide.selectors.menuWrapper);
      const menuItems = $(fitGuide.selectors.menuItem);
      const tabs = $(fitGuide.selectors.tab);
      const tabHeader = $(fitGuide.selectors.tabHeader);
      /**
       * @param item
       */
      function toggleActiveItem(item) {
        if (!item) return;
        const tabID = item.getAttribute(fitGuide.selectors.tabID);
        tabHeader[0].textContent = item.textContent;
        toggleElementsClass(menuItems, tabID);
        toggleElementsClass(tabs, tabID);
        tabsWrapper[0].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
      /**
       * @param array
       * @param tabID
       */
      function toggleElementsClass(array, tabID) {
        array.each(function (index, item) {
          if (item.getAttribute(fitGuide.selectors.tabID) === tabID) item.classList.add(fitGuide.selectors.activeClass);
          else item.classList.remove(fitGuide.selectors.activeClass);
        });
      }
      menuWrapper.on('click', function (e) {
        if (e.target.hasAttribute(fitGuide.selectors.tabID)) toggleActiveItem(e.target);
      });
      tabsWrapper.on('click', function (e) {
        if (e.target.classList.contains(fitGuide.selectors.accordionHeadClass)) {
          e.target.classList.toggle(fitGuide.selectors.activeClass);

          if (e.target.classList.contains(fitGuide.selectors.activeClass)) e.target.nextSibling.style.maxHeight = `${e.target.nextSibling.scrollHeight}px`;
          else e.target.nextSibling.style.maxHeight = `${0}px`;
        }
      });
      toggleActiveItem(menuItems[0]);
    },
    _run: () => fitGuide._init(),
  }),
  (globalThis.cartQuantityButtons = {
    selectors: {
      quantityButton: '.cart__qty-button',
      cartItemWrapperIndexAttr: 'data-cart-item-index',
      cartItemInputIndexAttr: 'data-quantity-item',
      plusNameAttr: 'plus',
    },
    _init: () => {
      if ($(cartQuantityButtons.selectors.quantityButton).length === 0) return;
      $(document).on('click', cartQuantityButtons.selectors.quantityButton, function () {
        const clickedButton = this;
        const cartItemIndex = clickedButton
          .closest(`[${cartQuantityButtons.selectors.cartItemWrapperIndexAttr}]`)
          .getAttribute(cartQuantityButtons.selectors.cartItemWrapperIndexAttr);
        const cartItemInput = $(`[${cartQuantityButtons.selectors.cartItemInputIndexAttr}='${cartItemIndex}']`)[0];
        const previousValue = cartItemInput.value;
        clickedButton.name === cartQuantityButtons.selectors.plusNameAttr ? cartItemInput.stepUp() : cartItemInput.stepDown();
        if (previousValue !== cartItemInput.value) cartItemInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    },
    _run: () => cartQuantityButtons._init(),
  });
globalThis.GDPRLegalCookies = {
  selectors: {
    sectionId: '#banner-wrapper',
    counter: 'summary .counter',
  },
  _check(sectionId, counter) {
    new MutationObserver(() => {
      if ($(counter, $(sectionId)).length > 0 && $(counter, $(sectionId)).text().indexOf(theme.strings.out_of) === -1) GDPRLegalCookies._initTranslate(sectionId, counter);
    }).observe($(sectionId).get(0), {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });
  },
  _initTranslate(sectionId, counter) {
    $(counter, $(sectionId)).each(function () {
      if ($(this).text().match(/\d+/g) === null) return;
      const counterList = $(this).text().match(/\d+/g).map(Number);
      if (counterList.length !== 2) return;
      $(this).text(` ( ${counterList[0]} ${theme.strings.out_of} ${counterList[1]} ) `);
    });
  },
  _init({ sectionId, counter }) {
    if (!$(sectionId).length) return;
    if (Shopify.locale != 'pl') return;
    this._check(sectionId, counter);
  },
  _run() {
    this._init(this.selectors);
  },
};
globalThis.announcementBar = {
  selectors: {
    customAnnBar: '#shopify-section-announcement-bar',
    bolideAnnBar: '.bolide-announcement-bar-wrap',
    stickyClass: 'sticky',
  },
  _moveBolideBar: () => {
    const bolideAnnBar = document?.querySelector(announcementBar.selectors.bolideAnnBar);
    const customAnnBar = document?.querySelector(announcementBar.selectors.customAnnBar);
    if (bolideAnnBar && customAnnBar) customAnnBar.insertAdjacentElement('afterbegin', bolideAnnBar);
  },
  _init: () => {
    const interval = setInterval(() => {
      let counter = 0;
      if (document.querySelector(announcementBar.selectors.bolideAnnBar)) {
        announcementBar._moveBolideBar();
        clearInterval(interval);
      }
      if (counter > 10) {
        clearInterval(interval);
      }
      counter++;
    }, 1000);
  },
  _run: () => announcementBar._init(),
};
globalThis.stickyHeader = {
  _throttle: (func, interval) => {
    let lastCall = 0;
    return function (...args) {
      const now = Date.now();
      if (now - lastCall >= interval) {
        lastCall = now;
        func.apply(this, args);
      }
    };
  },
  _getFiltersData: () => {
    const filters = document.querySelector('.snize-main-panel');
    const filtersHeight = filters ? filters.getBoundingClientRect().height * 1 : 0;
    return { filters, filtersHeight };
  },
  _getHeaderData: () => {
    const header = document.querySelector('#shopify-section-header');
    const headerHeight = header.getBoundingClientRect().height * 1;
    return { header, headerHeight };
  },
  _init: () => {
    if (window.innerWidth >= 769) return; // end script when desktop
    const { header, headerHeight } = stickyHeader._getHeaderData();
    const { filters, filtersHeight } = stickyHeader._getFiltersData();

    header.style.top = `${(headerHeight + filtersHeight + 1) * -1}px`;
    if (filters) filters.style.top = `${(filtersHeight + 2) * -1}px`;

    let lastScroll = 0;
    window.addEventListener(
      'scroll',
      stickyHeader._throttle(() => {
        const { header, headerHeight } = stickyHeader._getHeaderData();
        const { filters, filtersHeight } = stickyHeader._getFiltersData();
        header.style.top = `${(headerHeight + filtersHeight + 1) * -1}px`;
        if (filters) filters.style.top = `${(filtersHeight + 2) * -1}px`;
        const currentScroll = window.scrollY;
        if (currentScroll < headerHeight + filtersHeight + 200 || currentScroll > lastScroll) {
          header.style.transform = 'translateY(0px)';
          if (filters) filters.style.transform = 'translateY(0px)';
        } else if (currentScroll < lastScroll) {
          header.style.transform = `translateY(${headerHeight + filtersHeight}px)`;
          if (filters) filters.style.transform = `translateY(${headerHeight + filtersHeight}px)`;
        }
        lastScroll = currentScroll;
      }, 50)
    );
  },
  _run: () => stickyHeader._init(),
};
$(function () {
  cookies._run();
  if (Shopify.designMode) mutationMain();
  shopTheLook._run();
  menu._run();
  collectionView._run();
  searchaniseCustomization._run();
  fitGuide._run();
  cartQuantityButtons._run();
  GDPRLegalCookies._run();
  announcementBar._run();
  stickyHeader._run();
});
